$(document).on("click", ".question_product,.faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", ".read_more_js", function (e) {
    jQuery(this).prev().hide();
    jQuery(this).hide();
    jQuery(this).next().slideToggle();
    jQuery(this).next().next().show();
});
$(document).on("click", ".read_less_js", function (e) {
    jQuery(this).hide();
    jQuery(this).prev().slideToggle();
    jQuery(this).prev().prev().prev().show();
    jQuery(this).prev().prev().show();
});


$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});






$(document).on("click", "a[href='/#reviews']", function (e) {
 if( $('#faq').length ){
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
 }
});
$(document).on("click", "a[href='/#benifits']", function (e) {
 if( $('#faq').length ){
  e.preventDefault();
  document.querySelector('#benifits').scrollIntoView({
    behavior: 'smooth'
  })
 }
});

$(document).on("click", "a[href='#compare']", function (e) {
  e.preventDefault();
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#benifits']", function (e) {
  e.preventDefault();
  document.querySelector('#benifits').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.choose_text_product.choose_1').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});



  
$(document).on("click", ".custom_tabs_top_flex_item", function (e) {
var data_tab = $(this).attr('data_tab');
$('.custom_tabs_top_flex_item').removeClass('active');
$(this).addClass('active');
$('.custom_tabs_content').hide();
$('.custom_tabs_content[data_tab="'+data_tab+'"]').show();
});
$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});



$(document).on("click", '.search_trigger_button', function (e) {
var text = $(this).prev().val();
text = text.trim();
text = text.replace(" ", "+");
var link = '/search';
var new_link = link+'?q='+text;
  location.href=new_link;
});


$('.header_custom_search input').keypress(function (e) {
if (e.which == '13') {
 $(this).next().trigger('click');
}});



function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+200;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.custom_compare_lp ul li').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });
});


$(document).on("click", '.custom_slider_tag', function (e) {
var data_tab = parseInt($(this).attr('data_tab'));
$('.custom_slider_tag').removeClass('active');
$(this).addClass('active');
data_tab = data_tab -1;
  $('.built_list').slick('slickGoTo', data_tab);
});



$(".built_list").on("afterChange", function(event, slick, currentSlide){
var data_tab = slick.currentSlide + 1;
$('.custom_slider_tag').removeClass('active');
$('.custom_slider_tag[data_tab="'+data_tab+'"]').addClass('active');
});


$(document).on("click", '.close_custom_popup,.custom_upsell_popup_bg', function (e) {
$('.custom_upsell_popup').hide().removeClass('active');
});

